import { getAuthToken } from './auth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const apiRequest = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Ein Fehler ist aufgetreten' }));
    throw new Error(error.error || error.message || `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Paging helpers (shared contract with legacy admin)
export const PAGE_SIZES = [25, 50, 100];

export const toLimitOffset = (pageIndex = 0, pageSize = 50) => {
  const safePageIndex = Number.isFinite(pageIndex) && pageIndex >= 0 ? pageIndex : 0;
  const safePageSize = PAGE_SIZES.includes(pageSize) ? pageSize : 50;
  return { limit: String(safePageSize), offset: String(safePageIndex * safePageSize) };
};

// Auth API
export const login = (email, password) => {
  return apiRequest('/admin/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
};

export const verifyMFA = (email, emailCode, totpCode) => {
  return apiRequest('/admin/verify-mfa', {
    method: 'POST',
    body: JSON.stringify({ email, email_code: emailCode, totp_code: totpCode }),
  });
};

export const logout = () => {
  return apiRequest('/admin/logout', {
    method: 'POST',
  });
};

export const getMe = (adminId) => {
  return apiRequest(`/admin/me/${adminId}`);
};

// Users API
export const getUsers = (params = {}) => {
  const qs = new URLSearchParams(params);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return apiRequest(`/admin/users${suffix}`);
};

export const getUser = (userId) => {
  return apiRequest(`/admin/users/${userId}`);
};

export const getRegistrations = () => {
  return apiRequest('/admin/registrations');
};

export const approveRegistration = (registrationId, adminId, notes) => {
  return apiRequest(`/admin/registrations/${registrationId}/approve/${adminId}`, {
    method: 'POST',
    body: JSON.stringify({ notes }),
  });
};

export const rejectRegistration = (registrationId, adminId, notes) => {
  return apiRequest(`/admin/registrations/${registrationId}/reject/${adminId}`, {
    method: 'POST',
    body: JSON.stringify({ notes }),
  });
};

export const updateUser = (userId, body) => {
  return apiRequest(`/admin/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
};

export const deleteUser = (userId, adminId, body) => {
  return apiRequest(`/admin/users/${userId}/delete/${adminId}`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
};

// Companies API
export const getCompanies = () => {
  return apiRequest('/admin/companies');
};

export const getCompany = (companyId) => {
  return apiRequest(`/admin/companies/${companyId}`);
};

export const createCompany = (body) => {
  return apiRequest('/admin/companies', {
    method: 'POST',
    body: JSON.stringify(body),
  });
};

export const updateCompany = (companyId, body) => {
  return apiRequest(`/admin/companies/${companyId}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
};

// Licenses API
export const getLicenses = (filters = {}) => {
  const params = new URLSearchParams(filters);
  return apiRequest(`/admin/licenses?${params.toString()}`);
};

export const createLicense = (adminId, productCode, licenseType, expiresAt) => {
  return apiRequest(`/admin/licenses/${adminId}`, {
    method: 'POST',
    body: JSON.stringify({
      product_code: productCode,
      license_type: licenseType,
      expires_at: expiresAt,
    }),
  });
};

// MasterKey / Quoten (Lizenz-Begrenzung)
export const getMasterKeyQuotas = () => {
  return apiRequest('/admin/licenses/master-key');
};

export const createMasterKey = (masterKey) => {
  return apiRequest('/admin/licenses/master-key', {
    method: 'POST',
    body: JSON.stringify({ master_key: masterKey }),
  });
};

export const getLicense = (licenseKey) => {
  return apiRequest(`/admin/licenses/${licenseKey}`);
};

export const activateLicense = (licenseKey, userEmail) => {
  return apiRequest(`/admin/licenses/${licenseKey}/activate`, {
    method: 'POST',
    body: JSON.stringify({ user_email: userEmail }),
  });
};

export const deactivateLicense = (licenseKey) => {
  return apiRequest(`/admin/licenses/${licenseKey}/deactivate`, {
    method: 'POST',
  });
};

export const deleteLicense = (licenseKey) => {
  return apiRequest(`/admin/licenses/${licenseKey}`, {
    method: 'DELETE',
  });
};

export const renewLicense = (licenseKey, payload) => {
  return apiRequest(`/admin/licenses/${licenseKey}/renew`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

// Dashboard API
export const getDashboardStats = () => {
  return apiRequest('/admin/dashboard/stats');
};

// Email Logs API
export const getEmailLogs = (params = {}) => {
  const qs = new URLSearchParams(params);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return apiRequest(`/admin/email/logs${suffix}`);
};






